import { createFileRoute, redirect } from '@tanstack/react-router';
import { AppLayout } from '@/components/layout/app-layout';
import { ensureProvisionedMe, ensureSession } from '@/lib/route-guards';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ location, context }) => {
    const session = await ensureSession(context.queryClient);
    if (!session.data) {
      // Send unauthenticated users to /login with ?next= so they bounce back
      // to the page they tried to visit after signing in.
      throw redirect({ to: '/login', search: { next: location.href } });
    }
    // Resolve the caller's domain identity for the whole authenticated tree
    // (modules read it via `useMe()`). Redirects to /login (expired) or
    // /no-access (unprovisioned/blocked) as appropriate; rethrows transient
    // errors to the router error boundary rather than dead-ending the user.
    await ensureProvisionedMe(context.queryClient, location.href);
  },
  component: AppLayout,
});
